<template>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>
  <!-- Form -->
  <form @submit.prevent="store" class="form-content">
    <div class="form-content-inner">
      <control
        type="hidden"
        v-model="employeecareerpath.id"
        :hasError="!!errors.id"
        id="id"
      />

      <div class="form-col">
        <field
          :label="$t('employeecareerpath.careerpath')"
           class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
          :hasError="errors.career_path_id"
        >
          <control
            :options="careerPathList"
            :placeholder="$t('employeecareerpath.placeholder.careerpath')"
            v-model="employeecareerpath.career_path_id"
            id="career_path_id"
            :hasError="!!errors.career_path_id"
            @change="onChange(employeecareerpath, $event)"
          />
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('employeecareerpath.startdate')"
          class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
          :hasError="errors.employeecareerpath_year_id"
        >
          <datepicker
            v-model="employeecareerpath.start_date"
            :enableTimePicker="false"
            :auto-apply="true"
          ></datepicker>
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('employeecareerpath.decreenumb')"
          class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
          :hasError="errors.decree_no"
        >
          <control
            type="text"
            :placeholder="$t('employeecareerpath.placeholder.decreenumb')"
            v-model="employeecareerpath.decree_no"
            :hasError="!!errors.decree_no"
            id="decree_no"
          />
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('employeecareerpath.decreeExpiredDate')"
          class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
          :hasError="errors.decree_expire_date"
        >
          <datepicker
            v-model="employeecareerpath.decree_expire_date"
            :enableTimePicker="false"
            :auto-apply="true"
          ></datepicker>
        </field>
      </div>

      <div class="form-col">
        <field
          :label="$t('employeecareerpath.file_name')"
          class="w-full md:w-2/2 px-3 mb-6 md:mb-0"
          help="* support only pdf format"
          :hasError="errors.file_name"
        >
          <input
            type="file"
            accept="application/pdf"
            v-on:change="onFileChange"
            class="form-control-file"
            id="my-file"
          />
        </field>
      </div>

      <div
        class="buttons-submit transition-colors duration-1000"
        :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'"
      >
        <jb-buttons class="buttons-action-submit">
          <jb-button
            type="submit"
            color="info"
            :icon="mdiCheckBold"
            :label="$t('finance.button.btnSubmit')"
            class="form-submit-btn"
          />
          <jb-button
            type="button"
            color="info"
            outline
            :label="$t('finance.button.btnReset')"
            class="form-noicon-btn btn-reset"
            @click="reset()"
          />
        </jb-buttons>
      </div>
    </div>
  </form>
  <!-- Loading -->
  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"
    />
  </div>
</template>
<script>
/* eslint-disable */
import {
  ref,
  reactive,
  onMounted,
  onBeforeMount,
  watch,
  watchEffect,
} from "vue";
import axios from "axios";
import { mdiBallot, mdiCheckBold } from "@mdi/js";
import Control from "@/components/Control";
//   import CheckRadioPicker from '@/components/CheckRadioPicker'
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import JbButton from "@/components/JbButton";
import JbButtons from "@/components/JbButtons";
import Field from "@/components/Field";
import { useToast } from "vue-toastification";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// import { Year } from '@syncfusion/ej2-vue-schedule'
export default {
  name: "ClassForm",
  components: {
    Field,
    Control,
    Loading,
    //   CheckRadioPicker,
    JbButton,
    Datepicker,
    JbButtons,
  },
  props: {
    showEdit: { Boolean },
    propObject: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propClass: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propDepartment: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propYear: {
      type: Object,
      default: () => ({ empty: true }),
    },
    propLevel: {
      type: Object,
      default: () => ({ empty: true }),
    },
  },
  data: function () {
    return {};
  },
  emits: ["close-modal", "submit", "reset-modal"],
  setup(props, { emit }) {
    const titleStack = ref(["Admin", "Forms"]);

    const isLoading = ref(false);

    const toast = useToast();

    const router = useRouter();

    const errors = ref([]);

    const str = useStore();
    const userlogin = localStorage.getItem("name");

    const employeeList = ref();
    const careerPathList = ref();

    const preview = ref("");
    const image = ref({ name: "", size: 0 });


    const employeecareerpath = reactive({
      id: "",
      employee_id: "",
      employee_name: "",
      career_path_id: "",
      career_path_name: "",
      decree_no: "",
      decree_expire_date: "",
      file_name: "",
      start_date: "",
      created_by: "",
      updated_by: "",
    });
  
    const reset = () => {
      employeecareerpath.employee_id = "";
      employeecareerpath.employee_name = "";
      employeecareerpath.career_path_id = "";
      employeecareerpath.career_path_name = "";
      employeecareerpath.decree_no = "";
      employeecareerpath.decree_expire_date = "";
      employeecareerpath.file_name = "";
      employeecareerpath.start_date = "";
    };

    const store = async () => {
      isLoading.value = true;
      const url = props.showEdit
        ? "employee-career-path/" + employeecareerpath.id
        : "employee-career-path";
      const method = props.showEdit ? "PUT" : "POST";
      if (method === "POST") {
        employeecareerpath.created_by = userlogin;
      } else {
        employeecareerpath.updated_by = userlogin;
      }
      console.log("employeecareerpath", employeecareerpath);
      await axios({
        method,
        url,
        data: employeecareerpath,
      })
        .then((response) => {
          if (response.data.success) {
            emit("reset-modal");
            emit("close-modal");
            toast.success(response.data.message);
          } else {
            errors.value = response.data.messages;
            toast.error(response.data.messages);
          }
          isLoading.value = false;
          reset();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error);
            toast.error(error.response.data.message);
            console.log(JSON.stringify(error.request));
          } else if (error.message) {
            console.log(error.message);
            toast.error(error.message);
            console.log(JSON.stringify(error.message));
          }
          isLoading.value = false;
        });
    };

    const getEmployee = async () => {
      isLoading.value = true;
      await axios
        .get("employee")
        .then((response) => {
          employeeList.value = response.data.data;
          // filter.department_id = departmentList.value[0].id
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    const getCareerPath = async () => {
      isLoading.value = true;
      await axios
        .get("career-path")
        .then((response) => {
          careerPathList.value = response.data.data;
          // filter.department_id = departmentList.value[0].id
          isLoading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data, { timeout: 5000 });
          console.log(error);
          isLoading.value = false;
        });
    };

    const MaxUploadLimit = ref(0)
    const getUploadLimitProgramme = async () => {
      await axios
        .get("/upload-limit-programme")
        .then((res) => {
          MaxUploadLimit.value = res.data.data

        });
    };

    const onFileChange = async (event) => {
      const file = event.target.files[0];
      if (file) {
        // Validate file size (e.g., max 5MB)
        if (file.size > 5 * 1024 * 1024) {
          toast.error("File too big (> 5MB)");
          event.target.value = "";
          preview.value = "";
          image.value = { name: "", size: 0 };
          employeecareerpath.file_name = "";
          return;
        }

        // Validate file type
        if (file.type !== "application/pdf") {
          toast.error("Only PDF files are allowed");
          event.target.value = "";
          preview.value = "";
          image.value = { name: "", size: 0 };
          employeecareerpath.file_name = "";
          return;
        }

        // Read file as base64
        const reader = new FileReader();
        reader.onload = (e) => {
          preview.value = e.target.result;
          employeecareerpath.file_name = e.target.result; // Store base64 string
          image.value = {
            name: file.name,
            size: file.size,
          };
        };
        reader.onerror = () => {
          toast.error("Failed to read file");
          preview.value = "";
          image.value = { name: "", size: 0 };
          employeecareerpath.file_name = "";
        };
        reader.readAsDataURL(file);
      } else {
        // Clear if no file selected
        preview.value = "";
        image.value = { name: "", size: 0 };
        employeecareerpath.file_name = "";
      }
    };

    onBeforeMount(() => {});

    onMounted(() => {
      // academicyear.value =toRefs(props, 'propClass')
      getEmployee();
      getCareerPath();
      getUploadLimitProgramme();
    });

    watch(
      () => props.propClass,
      (newVal, oldVal) => {}
    );

    watchEffect(() => {
      const newobject = props.propObject;
      Object.assign(employeecareerpath, newobject);

      if (!props.showEdit) {
        employeecareerpath.id = null;
        employeecareerpath.employee_id = null;
        employeecareerpath.employee_name = null;
        employeecareerpath.career_path_id = null;
        employeecareerpath.career_path_name = null;
        employeecareerpath.decree_no = null;
        employeecareerpath.start_date = null;
      }

      const newemployeecareerpath = props.propClass;
      employeecareerpath.submenu = newemployeecareerpath.submenu;
      employeecareerpath.ein = newemployeecareerpath.ein;
      employeecareerpath.employee_id = newemployeecareerpath.employee_id;
      employeecareerpath.nickname = newemployeecareerpath.nickname;
    });

    return {
      isLoading,
      titleStack,
      employeeList,
      careerPathList,
      mdiBallot,
      mdiCheckBold,
      router,
      getEmployee,
      getCareerPath,
      employeecareerpath,
      store,
      toast,
      userlogin,
      errors,
      reset,
      str,
      preview,
      image,
      onFileChange,
      MaxUploadLimit
    };
  },
  methods: {
    clearForm() {
      this.employeecareerpath = reactive({
        id: "",
        employee_id: "",
        employee_name: "",
        career_path_id: "",
        career_path_name: "",
        decree_no: "",
        start_date: "",
        created_by: "",
      });
      this.image = { name: "", size: 0 };
      this.preview = "";
    },
    onChange: function (employee_id, event) {
      if (event.target.value) {
        employee_id = event.target.value;
      }
    },
  },
  // created () {
  //   this.levelListFilter = this.levelList
  //   this.academicYearListFilter = this.academicYearList
  // }
};
</script>
